<template>
    <div id="access-page" class="wide content">
        <h3>Access Requests</h3>

        <div class="requests">
            <div class="awaiting">
                <h6>Unapproved</h6>
                <div class="item" v-for="req in unapprovedRequests" :key="req.id">
                    <p><strong>User:</strong> {{ req.user.username }}</p>
                    <p><strong>Company:</strong> {{ req.user.company }}</p>
                    <p><strong>Industry Role:</strong> {{ req.user.industry_role }}</p>
                    <p><strong>Folder:</strong> {{ req.folder.display_name }}</p>
                    <p><strong>Time:</strong> {{ req.created|fmtdate }}</p>
                    <p>
                        <a href="#" @click.prevent="approveRequest(req.id)">Approve</a> -
                        <a href="#" @click.prevent="deleteRequest(req.id)">Delete</a>
                    </p>
                </div>
            </div>
            <div class="approved">
                <h6>Approved</h6>
                <div class="item" v-for="req in approvedRequests" :key="req.id">
                    <p><strong>User:</strong> {{ req.user.username }}</p>
                    <p><strong>Company:</strong> {{ req.user.company }}</p>
                    <p><strong>Industry Role:</strong> {{ req.user.industry_role }}</p>
                    <p><strong>Folder:</strong> {{ req.folder.display_name }}</p>
                    <p><strong>Time:</strong> {{ req.created|fmtdate }}</p>
                    <p>
                        <a href="#" @click.prevent="revokeAccess(req.id)">Revoke</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    name: 'access-page',
    data() {
        return {
            requests: [],
        }
    },
    computed: {
        unapprovedRequests() {
            return this.requests.filter(r => r.approved == null)
        },
        approvedRequests() {
            return this.requests.filter(r => r.approved != null)
        },
    },
    methods: {
        async getRequests() {
            let r = await axios.get('/api/access-requests', {
                params: {
                    'order': 'modified.desc',
                }
            })

            if (r.status != 200) {
                return;
            }

            this.requests = r.data.access_requests
        },
        async deleteRequest(id) {
            let r = await axios.delete(`/api/access-requests/${id}`)
            if (r.status != 200) {
                return;
            }

            this.getRequests()
        },
        async revokeAccess(id) {
            let r = await axios.post(`/api/access-requests/revoke/${id}`)
            if (r.status != 200) {
                return;
            }

            this.getRequests()
        },
        async approveRequest(id) {
            let r = await axios.post(`/api/access-requests/approve/${id}`)
            if (r.status != 200) {
                return;
            }

            this.getRequests()
        },
    },
    created() {
        this.getRequests()
    }
}
</script>
<style lang="scss">
@import '../scss/include-media';
#access-page {
    padding: 50px 100px;
    @include media("<=tablet") {
        padding: 50px;
    }
    &.content {
        @include media(">tablet") {
            max-width: 65vw;
        }
    }

    .requests {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-areas: "awaiting approved";
        grid-gap: 2rem;

        .awaiting {
            // grid-column: 1/2;
            grid-area: awaiting;
        }
        .approved {
            // grid-column: 2/3;
            grid-area: approved;
        }

        .item {
            padding-bottom: 1rem;
            margin-bottom: 1rem;
            border-bottom: solid 1px #333;
            p {
                margin-bottom: 0.25rem;
            }
        }
    }
}
</style>
